export const EmissionSourceEquipments: string[] = [
  '0000',
  '0001',
  '0002',
  '0003',
  '0004',
  '0005',
  '0006',
  '0007',
  '0010',
  '0020',
  '0099',
  '0100',
  '0101',
  '0102',
  '0103',
  '0199',
  '0200',
  '0201',
  '0299',
  '0300',
  '0301',
  '0302',
  '0303',
  '0304',
  '0305',
  '0306',
  '0307',
  '0308',
  '0399',
  '0999',
  '1000',
  '1001',
  '1002',
  '1009',
  '1010',
  '1011',
  '1012',
  '1013',
  '1020',
  '1030',
  '1040',
  '1050',
  '1060',
  '1090',
  '1099',
  '1100',
  '1110',
  '1120',
  '1130',
  '1140',
  '1150',
  '1160',
  '1190',
  '1191',
  '1192',
  '1193',
  '1194',
  '1195',
  '1199',
  '1200',
  '1201',
  '1202',
  '1209',
  '1210',
  '1211',
  '1212',
  '1219',
  '1220',
  '1221',
  '1222',
  '1229',
  '1230',
  '1231',
  '1239',
  '1240',
  '1250',
  '1260',
  '1290',
  '1291',
  '1292',
  '1293',
  '1294',
  '1295',
  '1296',
  '1298',
  '1299',
  '2000',
  '2001',
  '2010',
  '2020',
  '2099',
  '3000',
  '3001',
  '3010',
  '3020',
  '3030',
  '3040',
  '3099',
  '3100',
  '3110',
  '3120',
  '4000',
  '4010',
  '4090',
  '4091',
  '4092',
  '4093',
  '4094',
  '4095',
  '4096',
  '4097',
  '4098',
  '4099',
  '4100',
  '4101',
  '4110',
  '4120',
  '4130',
  '4140',
  '4150',
  '4160',
  '4170',
  '4180',
  '4190',
  '4199',
  '5000',
  '5010',
  '5020',
  '5030',
  '5040',
  '5050',
  '5060',
  '5070',
  '5080',
  '5099',
  '5100',
  '5110',
  '5120',
  '5130',
  '5140',
  '5199',
  '6000',
  '6010',
  '6020',
  '6030',
  '6099',
  '7000',
  '7010',
  '7020',
  '7030',
  '7040',
  '7050',
  '7060',
  '7070',
  '7080',
  '7081',
  '7082',
  '7099',
  '7100',
  '7110',
  '7120',
  '7130',
  '7140',
  '7199',
  '7200',
  '7210',
  '7900',
  '7910',
  '7920',
  '7930',
  '7940',
  '7950',
  '7960',
  '7999',
  '8000',
  '8001',
  '8002',
  '8003',
  '8004',
  '8010',
  '8099',
  '8100',
  '8101',
  '8102',
  '8103',
  '8104',
  '8199',
  '8200',
  '8210',
  '8220',
  '8230',
  '8298',
  '8299',
  '8300',
  '8301',
  '8302',
  '8303',
  '8397',
  '8398',
  '8399',
  '8400',
  '8410',
  '8420',
  '8499',
  '8500',
  '8510',
  '8599',
  '8600',
  '8610',
  '8620',
  '8630',
  '8699',
  '8800',
  '8801',
  '8810',
  '8820',
  '8830',
  '8840',
  '8841',
  '8842',
  '8850',
  '8860',
  '8861',
  '8862',
  '8870',
  '8871',
  '8872',
  '8873',
  '8880',
  '8890',
  '8900',
  '8910',
  '8911',
  '8920',
  '8930',
  '8940',
  '8950',
  '8980',
  '8981',
  '8982',
  '8983',
  '8984',
  '8985',
  '8992',
  '8993',
  '8994',
  '8995',
  '8996',
  '8997',
  '8998',
  '8999',
  '9000',
  '9001',
  '9002',
  '9003',
  '9004',
  '9005',
  '9006',
  '9007',
  '9008',
  '9009',
  '9010',
  '9011',
  '9012',
  '9013',
  '9014',
  '9015',
  '9016',
  '9017',
  '9020',
  '9021',
  '9022',
  '9024',
  '9027',
  '9028',
  '9029',
  '9030',
  '9031',
  '9032',
  '9033',
  '9034',
  '9035',
  '9036',
  '9037',
  '9038',
  '9039',
  '9040',
  '9041',
  '9042',
  '9043',
  '9794',
  '9795',
  '9796',
  '9797',
  '9798',
  '9799',
  '9800',
  '9997',
  '9998',
  '9999',
  'A100',
  'A101',
  'A109',
  'A110',
  'A119',
  'A120',
  'A121',
  'A122',
  'A129',
  'A130',
  'A133',
  'A139',
  'A140',
  'A150',
  'A160',
  'A167',
  'A168',
  'A169',
  'A179',
  'A180',
  'A190',
  'A200',
  'A201',
  'A210',
];
